/* tslint:disable */

declare var Object: any;
export interface ObjectHelpCardInterface {
  "helpCardTypeId": number;
  "objectTypeId": number;
  "objectId": number;
  "name": string;
  "displayName"?: string;
  "active"?: boolean;
  "data": any;
  "order": number;
  "languageCode"?: any;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class ObjectHelpCard implements ObjectHelpCardInterface {
  "helpCardTypeId": number;
  "objectTypeId": number;
  "objectId": number;
  "name": string;
  "displayName": string;
  "active": boolean;
  "data": any;
  "order": number;
  "languageCode": any;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: ObjectHelpCardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObjectHelpCard`.
   */
  public static getModelName() {
    return "ObjectHelpCard";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObjectHelpCard for dynamic purposes.
  **/
  public static factory(data: ObjectHelpCardInterface): ObjectHelpCard{
    return new ObjectHelpCard(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ObjectHelpCard',
      plural: 'ObjectHelpCards',
      path: 'ObjectHelpCards',
      idName: 'id',
      properties: {
        "helpCardTypeId": {
          name: 'helpCardTypeId',
          type: 'number'
        },
        "objectTypeId": {
          name: 'objectTypeId',
          type: 'number'
        },
        "objectId": {
          name: 'objectId',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "order": {
          name: 'order',
          type: 'number',
          default: 0
        },
        "languageCode": {
          name: 'languageCode',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
